var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show || _vm.loader)?_c('div',{staticClass:"maj"},[(_vm.loader)?[_vm._v(" Mise à jour en cours ")]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }